// extracted by mini-css-extract-plugin
export var heading = "style-module--heading--71d8a";
export var reducingImpact = "style-module--reducingImpact--63ec8";